import type { FormKitNode } from '@formkit/core'
export default (node: FormKitNode): boolean => typeof node.value === 'string' && /^[0-9]{2}[-][0-9]{3}$/.test(node.value)